import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
// Detect mobile vs desktop on load. Priority: URL override (?mobile=1 or ?mobile=0), then screen width, then userAgent.
try {
  const urlParams = new URLSearchParams(window.location.search);
  let isMobile = null;
  if (urlParams.has('mobile')) {
    isMobile = urlParams.get('mobile') === '1' || urlParams.get('mobile') === 'true';
  } else {
    // width-based detection
    isMobile = window.innerWidth <= 768;
    // fallback to userAgent sniff for phones
    if (!isMobile && /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      isMobile = true;
    }
  }
  if (isMobile) document.documentElement.classList.add('mobile-version');
  else document.documentElement.classList.add('desktop-version');
} catch (e) {
  // ignore in SSR or unusual environments
}

root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
